import { storage } from '../product/productStorage';

// Report entries (views / likes per post) live in localStorage, per product, and
// are shared by the Report tab, the Content Plan (which logs results for planned
// posts) and the dashboard.
const STORAGE_KEY = 'videoEntries';

export const loadReportEntries = () => {
    const saved = storage.getJson(STORAGE_KEY, []);
    return Array.isArray(saved) ? saved : [];
};

export const saveReportEntries = (entries) => {
    storage.setJson(STORAGE_KEY, entries);
};

// Plan platforms are labels ('TikTok'), report platforms are ids ('tiktok')
export const toReportPlatform = (platform = '') => platform.toLowerCase().replace(/\s+/g, '');

// Adds or updates the report entry for a planned post
export const upsertPlanPostEntry = (post, postDate, changes) => {
    const entries = loadReportEntries();
    const existing = entries.find(entry => entry.planPostId === post.id);
    const next = existing
        ? entries.map(entry => (entry === existing ? { ...entry, ...changes } : entry))
        : [...entries, {
            id: Date.now(),
            platform: toReportPlatform(post.platform),
            videoType: '',
            description: post.theme || post.hook,
            views: 0,
            likes: 0,
            postDate,
            planPostId: post.id,
            linkSlug: post.linkSlug,
            ...changes,
        }];
    saveReportEntries(next);
    return next;
};
